import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Emblem } from "@/components/Logo";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const { refreshUser } = useAuth();
  const [status, setStatus] = useState("checking");
  const sessionId = params.get("session_id");

  useEffect(() => {
    if (!sessionId) { setStatus("error"); return; }
    let tries = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") { setStatus("paid"); refreshUser(); return; }
        if (data.status === "expired" || tries > 12) { setStatus("error"); return; }
      } catch { if (tries > 12) { setStatus("error"); return; } }
      tries += 1; setTimeout(poll, 2000);
    };
    poll();
  }, [sessionId]);

  return (
    <div className="min-h-screen bg-ink grain flex items-center justify-center p-6">
      <div className="matte-card p-12 text-center max-w-md w-full">
        <Emblem className="h-12 w-12 mx-auto mb-6" />
        {status === "checking" && <><Loader2 size={40} className="animate-spin text-gold mx-auto mb-4" /><h1 className="font-serif text-3xl">Confirming your subscription…</h1></>}
        {status === "paid" && <><CheckCircle2 size={44} className="text-green-400 mx-auto mb-4" /><h1 className="font-serif text-4xl gold-text">You're plated in.</h1><p className="text-white/55 mt-3">Your plan is active. Welcome to the command center.</p><Link to="/dashboard" className="btn-gold inline-block mt-7 px-8 py-3.5 text-xs uppercase tracking-widest rounded-sm">Go to Dashboard</Link></>}
        {status === "error" && <><XCircle size={44} className="text-red-400 mx-auto mb-4" /><h1 className="font-serif text-3xl">Payment not confirmed</h1><p className="text-white/55 mt-3">We couldn't confirm your payment. If you were charged it may take a moment.</p><Link to="/pricing" className="btn-outline-gold inline-block mt-7 px-8 py-3.5 text-xs uppercase tracking-widest rounded-sm">Back to Pricing</Link></>}
      </div>
    </div>
  );
}
